import { em } from 'polished'
import styled from 'styled-components'

import DynamicImage from 'components/DynamicImage'

export const Wrapper = styled.div`
  margin-left: ${em(-20)};
  margin-right: ${em(-20)};
`

export const DynamicImageStyled = styled(DynamicImage)`
  max-width: ${em(400)};
  display: block;
  margin: auto;
`
